import { QUERY_KEY } from '@constants/queries';

import { useQuery } from '@tanstack/react-query';
import { GET } from '@lib/axios';
import { PublicSetting } from '@utils/typesPages/types';
import { PublicSettingsType } from '@pages/api/types';

export const fetchPublicSetting = async (key: PublicSettingsType) => {
  const { data: response } = await GET<PublicSetting>(
    `/api/public-settings/${key}`,
    {
      params: { key },
    }
  );

  return response;
};

export const useFetchPublicSetting = (key: PublicSettingsType) => {
  return useQuery({
    queryKey: [QUERY_KEY.FETCH_PUBLIC_SETTING, key],
    queryFn: () => fetchPublicSetting(key),
    refetchInterval: 300000,
    gcTime: 300000,
  });
};
